var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7755_34911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.48 20.2999H3.75C3.55189 20.2974 3.36263 20.2175 3.22253 20.0774C3.08244 19.9373 3.00259 19.748 3 19.5499V5.68994C3 5.49103 3.07902 5.30026 3.21967 5.15961C3.36032 5.01896 3.55109 4.93994 3.75 4.93994H8.75V6.38994H4.5V18.7999H16.73V14.5399H18.22V19.5399C18.2213 19.6384 18.2032 19.7362 18.1668 19.8277C18.1303 19.9192 18.0761 20.0026 18.0074 20.0732C17.9387 20.1438 17.8568 20.2001 17.7663 20.239C17.6758 20.2779 17.5785 20.2986 17.48 20.2999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6912 3.21919L10.8706 11.0398L11.9242 12.0934L19.7448 4.27278L18.6912 3.21919Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1101 9.83H18.6001V4.5H12.6001V3H19.3801C19.5773 3.00263 19.7655 3.08281 19.904 3.22317C20.0425 3.36354 20.1201 3.55281 20.1201 3.75L20.1101 9.83Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 13.73C10.6642 13.73 11 13.3942 11 12.98C11 12.5658 10.6642 12.23 10.25 12.23C9.83579 12.23 9.5 12.5658 9.5 12.98C9.5 13.3942 9.83579 13.73 10.25 13.73Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7755_34911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.11,
    height: 17.29,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/ExternalLink.e1d3ae1f.svg";
export { ForwardRef as ReactComponent };